module.exports = __webpack_public_path__ + "img/zm_fuzhen@3x.aad646f3.png";